import React from 'react';

export const SvgOfflineBolt = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.02 12c0-5.51 4.47-9.98 9.98-9.98 5.51 0 9.98 4.47 9.98 9.98 0 5.51-4.47 9.98-9.98 9.98-5.51 0-9.98-4.47-9.98-9.98zm9.46 1.74v4.14c0 .53.71.7.95.22l3.56-7.12a.502.502 0 00-.45-.72H13V6.07c0-.53-.71-.7-.94-.23l-3.68 7.17c-.18.33.07.73.44.73h2.66z"
      fill="currentColor"
    />
  </svg>
);
